const DESIGN_WIDTH = 1440;
const MIN_ZOOM = 0.85;

function canZoom() {
  return typeof CSS !== "undefined" && typeof CSS.supports === "function" && CSS.supports("zoom", "1");
}

function isWindowsDesktop() {
  return /Windows/i.test(navigator.userAgent) && window.matchMedia("(min-width: 1100px)").matches;
}

export function applyDisplayScale() {
  const root = document.documentElement;
  let zoom = 1;
  // innerWidth is independent of html { zoom }, so this cannot oscillate.
  // Do not invert devicePixelRatio: that fights OS/browser zoom and accessibility.
  if (isWindowsDesktop() && canZoom()) {
    const width = window.innerWidth;
    if (width > 0 && width < DESIGN_WIDTH) {
      zoom = Math.max(MIN_ZOOM, width / DESIGN_WIDTH);
    }
  }
  root.style.setProperty("--app-zoom", String(zoom));
}

export function watchDisplayScale() {
  applyDisplayScale();
  window.addEventListener("resize", applyDisplayScale);
  window.visualViewport?.addEventListener("resize", applyDisplayScale);
  return () => {
    window.removeEventListener("resize", applyDisplayScale);
    window.visualViewport?.removeEventListener("resize", applyDisplayScale);
  };
}
